import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import ArticleList from "./pages/ArticleList";
import ArticleDetail from "./pages/ArticleDetail";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/Dashboard";
import ArticleBuilder from "./pages/admin/ArticleBuilder";
import ArticlesList from "./pages/admin/ArticlesList";
import AudienceData from "./pages/admin/AudienceData";
import TestimonialsManager from "./pages/admin/TestimonialsManager";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith('/admin');
  const isLogin = location.pathname === '/login';

  return (
    <>
      {!isAdmin && !isLogin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/articles/:category" element={<ArticleList />} />
        <Route path="/article/:slug" element={<ArticleDetail />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="articles" element={<ArticlesList />} />
          <Route path="articles/new" element={<ArticleBuilder />} />
          <Route path="articles/:articleId" element={<ArticleBuilder />} />
          <Route path="audience" element={<AudienceData />} />
          <Route path="testimonials" element={<TestimonialsManager />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isAdmin && !isLogin && <Footer />}
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
